import React from 'react';

import { Control, Grid, GridCol, GridRow } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import validate from 'validators';

import st from './LogsFilterForm.module.sass';

export function LogsFilters({ streamIdsOptions }) {
  const { control, register, formState: { errors } } = useFormContext();
  const { t } = useTranslation();

  return (
    <Grid>
      <GridRow>
        <GridCol cols={4} contentClassName={st.DateField}>
          <Control.DateInput
            className={st.DateField}
            control={control}
            enableTime
            errors={errors}
            id="dateRange"
            label={t('lunaStreamsLogs:форма.дата от')}
            name="log_time__gte"
          />
          <Control.DateInput
            className={st.DateField}
            control={control}
            enableTime
            errors={errors}
            id="dateRange"
            label={t('lunaStreamsLogs:форма.дата до')}
            name="log_time__lt"
          />
        </GridCol>
        <GridCol cols={3}>
          <div className={st.FormField}>
            <Control.Input
              autoFocus
              errors={errors}
              label={t('lunaStreamsLogs:айди аккаунта')}
              {...register('account_id', {
                validate: validate.uuid(),
              })}
            />
            <Control.Select
              control={control}
              errors={errors}
              id="stream_ids"
              isClearable
              isMulti
              label={t('lunaStreamsLogs:форма.видеопоток')}
              name="stream_ids"
              options={streamIdsOptions}
              rules={{ validate: validate.uuid }}
            />
          </div>
        </GridCol>
        <GridCol cols={2}>
          <div className={st.LogsFilter__Subtitle}>
            {t('lunaStreamsLogs:форма.статусы')}
          </div>

          <div className={st.FormField}>
            <Control.Checkbox
              label="In progress"
              value="in_progress"
              {...register('statuses')}
            />
            <Control.Checkbox
              label="Pending"
              value="pending"
              {...register('statuses')}
            />
            <Control.Checkbox
              label="Pause"
              value="pause"
              {...register('statuses')}
            />
            <Control.Checkbox
              label="Restart"
              value="restart"
              {...register('statuses')}
            />
            <Control.Checkbox
              label="Failure"
              value="failure"
              {...register('statuses')}
            />
          </div>
        </GridCol>
      </GridRow>
    </Grid>
  );
}

LogsFilters.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  streamIdsOptions: PropTypes.arrayOf(PropTypes.object),
};

LogsFilters.defaultProps = {
  streamIdsOptions: [],
};
